export default {
  // 按钮
  imageChangeDetection: '变化检测',
  query: '查询',
  reset: '重置',
  viewFiles: '查看文件',
  annotate: '标注',
  download: '下载',
  downloadFile: '下载文件',
  table: '表格',
  card: '卡片',

  // 标签
  fileName: '文件名',
  createDate: '创建日期',
  folder: '文件夹',
  jobName: '作业名',
  jobId: '作业ID',
  createTime: '创建时间',
  preview: '预览',

  // 占位符
  fileNamePlaceholder: '文件名',
  startTime: '开始时间',
  endTime: '结束时间',

  // 表格列
  columnName: '文件名',
  columnJobName: '作业名',
  columnJobId: '作业ID',
  columnCreateTime: '创建时间',
  columnImageVideo: '图片/视频',
  columnAction: '操作',

  // 路由
  allFiles: '全部文件',

  // 机器人媒体类型
  typeZm: '中免',
  typeSmt: 'smt',
  typeRetail: '零售',

  // 空状态
  noMediaData: '暂无媒体数据',
  loading: '加载中...',

  // 消息
  modelMaking: '模型制作中,请稍后查看',
  downloading: '下载中',
  annotationNotSupported: '当前文件暂不支持进入标注',
  annotationImageNotFound: '未找到可标注的图片地址',
  annotationMissingJobInfo: '缺少作业信息，无法进入标注',

  // 绘图状态
  drawingStatus: {
    10: '等待处理',
    20: '处理中',
    30: '处理失败',
    60: '处理完成',
    50: '已取消',
  },

  // 图片预览组件
  imageLoadFailed: '图片加载失败',
  videoLoadFailed: '视频加载失败',
  loadFailed: '加载失败',
  detailInfo: '详细信息',
  fileNameLabel: '文件名称：',
  taskNameLabel: '任务名称：',
  routeNameLabel: '航线名称：',
  payloadLabel: '拍摄负载：',
  captureTimeLabel: '拍摄时间：',
  downloadLabel: '下载：',
  alarmInfo: '告警信息',
  accountNameLabel: '账号名称：',
  alarmModelLabel: '告警模型：',
  alarmTimeLabel: '告警时间：',
  fileLocationLabel: '文件位置：',
  noLocationInfo: '暂无位置信息',
  pointFlightDetail: '指点飞行详情',
  nameLabel: '名称：',
  fileSizeLabel: '文件大小',
  markAsFalseAlarm: '是否标记该图片误报?',
  markSuccess: '标记成功',

  // 工具栏按钮提示
  zoomIn: '放大',
  zoomOut: '缩小',
  restore: '还原',
  markFalseAlarm: '标记误报',
}
